<div class="">
    <div class="custella-modal d-flex flex-column">
        <div class="custella-modal-header align-items-center">
            <div class="custella-modal-header-text">
                <div class="font-medium text-14">Add Components</div>
            </div>
            <i class="fa-regular fa-xmark fa-lg" [pTooltip]="translate?.general.buttons.close.singular"
                tooltipPosition="left" (click)="modalRef.hide()"></i>
        </div>

        <div class="custella-modal-body p-0">
            <div class="custella-form-container box-none m-0 h-100">
                <div class="custella-form-container-title-two-grey">
                    <div class="font-medium text-14">Select components that you’d like to add to this asset</div>
                </div>
                 <div class="p-datatable p-component p-datatable-responsive-scroll">
                    <div class="p-datatable-wrapper">
                        <table role="table" class="p-datatable-table w-100">
                            <thead class="p-datatable-thead">
                                <tr>
                                    <th class="ps-3 w-30-prcnt">{{translate?.asset.fields.parent.singular}}</th>
                                    <th class="ps-0 w-24p5-prcnt">{{translate?.asset.label.singular}}</th>
                                    <th class="ps-0 w-20-prcnt">{{translate?.asset.fields.serialNo.singular}}</th>
                                    <th class="ps-0 w-20-prcnt">{{translate?.asset.fields.type.singular}}</th>
                                    <th class="px-2"></th>
                                </tr>
                            </thead>
                            <tbody class="p-element p-datatable-tbody">
                                <!-- New Row -->
                                <tr *ngFor="let assetData of assetsList;index as rowIndex">
                                     <td class="ps-3 w-20-prcnt" scope="row" pInputText autocomplete="off">
                                        <input type="text" class="form-control" disabled [(ngModel)]="assetData.parent.name" [ngModelOptions]="{standalone: true}">
                                    </td>
                                    <td class="ps-3 w-20-prcnt" scope="row" pInputText autocomplete="off">
                                             
                                         <form [formGroup]="addBinForm[rowIndex]" (keydown.enter)="$event.preventDefault()">
                                               <input type="text" *ngIf="assetData?.id" formControlName="asset" class="form-control" disabled [(ngModel)]="assetData.name">
                                                <div class="custella-content-row-input col-12" *ngIf="!assetData?.id">
                                                    <div class="p-inputgroup search">
                                                        <span class="p-input-icon-right w-100">
                                                               <p-autoComplete styleClass="w-100" 
                                                               appendTo="body" [(ngModel)]="assetData.asset"
                                                                id="picklist_InvProdAssetNameField" 
                                                                (onBlur)="onvalidAsset(rowIndex)"
                                                                 (onSelect)="selectValueAssets($event, rowIndex)"
                                                                field="name" formControlName="asset" [suggestions]="assets"
                                                                (onKeyUp)="getAssetIdsFirstWay($event, rowIndex)" 
                                                                [placeholder]="translate?.general.messages.none">   
                                                                                </p-autoComplete>
                                                                <i *ngIf="equipmentType" (click)="clearValueAssets(rowIndex)"   class="p-autocomplete-clear-icon pi pi-times"></i>
                                                            </span>
                                                        <button type="button" pButton icon="fa-regular fa-magnifying-glass" [pTooltip]="translate?.asset.tooltips.assetLookup.singular" tooltipPosition="left" (click)="showAssetsTable(rowIndex)" id="btn_CheckAssetSearch"></button>
                                                    </div>

                                                    <div *ngIf="addBinForm[rowIndex].controls['asset'].touched && addBinForm[rowIndex].controls['asset'].invalid">
                                                        <small class="text-10 p-error" *ngIf="addBinForm[rowIndex].controls['asset'].errors?.required">{{translate?.general.validationFE.requiredField}}</small>
                                                    </div>
                                                </div>
                                           </form>     
                                    </td>
                                   
                                    <td class="ps-0 w-15-prcnt" scope="row" pInputText autocomplete="off">
                                        <input type="text" class="form-control" disabled [(ngModel)]="assetData.serialNo" [ngModelOptions]="{standalone: true}">
                                    </td>
                                    <td class="ps-0 w-20-prcnt" scope="row" pInputText autocomplete="off">
                                        <input type="text" class="form-control" disabled [(ngModel)]="assetData.assetsType.name" [ngModelOptions]="{standalone: true}">
                                    </td>
                                    <td>
                                     <button *ngIf="(rowIndex !== 0 && !assetsList[1]?.id) || (rowIndex !== 0 && assetsList.length > 1) " pButton type="button" [pTooltip]="translate?.general.buttons.remove.singular" icon="fa-regular fa-xmark" tooltipPosition="top" class="p-button-danger ms-2"
                                                (click)="deleteAssetsRow(rowIndex)"></button>
                                    </td>
                                </tr>
                                <tr>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="custella-content-row mb-3">
                    <div class="custella-content-row-input col-6">
                        <p-button type="button" icon="fa-regular fa-plus" styleClass="ms-3 h-32" [pTooltip]="translate?.general.buttons.add.singular" (onClick)="addRow()"></p-button>
                    </div>
                </div>
            </div>
        </div>
          <div class="custella-modal-footer flex-align-center justify-content-end">
            <div class="flex-align-center justify-content-between col-12" >
                    <div class="flex-align-center gap-3">
                        <div class="flex-align-center">
                            <p-checkbox class="my-2" [binary]="true" [(ngModel)]="updateChildAssetsWithParentAssetsValues"></p-checkbox>
                            <span class="text-12 ms-2"> Update fields of component(s) to match the parent asset.</span>
                        </div>
                       
                    </div>
                    <div class="flex-align-center">
                    <button class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
                    <p-button type="button" [label]="translate?.general.buttons.save.singular" styleClass="ms-2" (onClick)="submitForm()"></p-button>
                </div>
            </div>
        </div>
    </div>
</div>
<footer *ngIf="showingAssetTable" class="custella-form-container-footer hidePopup">
    
    <p-dialog [header]="translate?.asset.sections.sec16.singular" [(visible)]="showingAssetTable" showEffect="fade" [style]="{ width: '70vw' }" [modal]="true" [draggable]="false">
        <app-custella-assets (closeAssetView)="closeAssetView()" (assetSelector)="gotSelectedAsset($event)" [eligibleChildAssets]="true" [assetsIgnoreId]="assetsIgnoreId"></app-custella-assets>
    </p-dialog>
</footer>
